<template>
  <div class="class-show">
    <div class="class-show-banner">
      <img src="@/assets/studyClass/dp-xx-ba1.png" alt />
      <p>{{msg.studyname}}</p>
      <div class="class-show-banner-branch">
        <img src="@/assets/studyClass/dp-xx-icon1.png" />
        <span>{{msg.branchName}}</span>
      </div>
      <div class="class-show-banner-exam">
        <span>{{msg.Number}}门课程</span>
        <span>1场考试</span>
      </div>
      <div class="class-show-banner-time">学习时间：{{msg.starttime}}—{{msg.endtime}}</div>
      <div class="class-show-banner-progress">
        <p>学习进度：</p>
        <el-progress :percentage="msg.Percentage*1" :color="[{color:'#f56c6c'}]"></el-progress>
      </div>
      <div class="class-show-banner-study" v-if="msg.state==0">
        <button @click="goDetail(msg.id)">进入学习</button>
      </div>
      <div class="class-show-banner-cert" v-if="msg.state==1" @click="showCert(msg.id)">
        <img src="@/assets/studyClass/dp-xx-zs2.png" alt />
      </div>
    </div>
    <div class="class-show-motai" @click="hide()" v-show="motaiShow">
      <div class="class-show-motai-cert" @click.stop>
        <img src="@/assets/studyClass/dp-xx-zs.png" />
        <div class="class-show-motai-cert-text">
          <p>
            <span>{{cert.name}}</span>，同志
          </p>
          <p>
            {{cert.certificate}}
          </p>
          <div class="branch"> <p>发证单位:</p>  <li>{{cert.branchName}}</li> </div>
          <p>发证时间:{{cert.certitime}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      cert: {
        name: "xxx",
        startTime: "2020年01月01日",
        endTime: "2020年04月04日",
        theam: "不忘初心，牢记使命，主题教育",
        sendTime: "2020年02月07日",
        adressCert: "东坡区党委"
      },
      motaiShow: false
    };
  },
  mounted() {},
  methods: {
    showCert(studyId) {      
      this.axios.get(
        `/api/Index/GetCertificate?userid=${sessionStorage.getItem(
          "id"
        )}&studyid=${studyId}`).then(e => {
          if (e.data.code == 0) {
            // console.log(e.data.msg);
            this.cert = e.data.msg[0]
          }
        })
      
      this.motaiShow = true;
    },
    hide() {
      this.motaiShow = false;
    },
    goDetail(id) {
      this.$router.push({
        path: "/study/detail",
        query: {
          title: "主题教育学习",
          id: id
        }
      });
    }
  },
  props: {
    msg: Object
  }
};
</script>
<style lang='scss' scoped>
.class-show {
  .branch{
    li{
      font-size: .24rem;
      color: #666666;
    }
    p{
      width: 2rem;
    }
    display: flex;
    margin-top: .2rem;
    text-align: left;
  }
  &-motai {
    &-cert {
      &-text {
        p {
          span {
            color: #000;
            font-weight: bold;
          }
          &:nth-child(3) {
            margin-top: 0.3rem;
          }
          text-align: left;
          text-indent: 0.2rem;
          font-size: 0.26rem;
          color: #666666;
        }
        position: absolute;
        top: 6.8rem;
        left: 15%;
        width: 70%;
      }
      img {
        width: 80%;
        margin-top: 3rem;
      }
      text-align: center;
      position: relative;
    }
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 11;
  }
  &-banner {
    &-cert {
      img {
        width: 2rem !important;
        height: 2rem;
      }
      position: absolute;
      right: 0.2rem;
      bottom: 0.75rem;
    }

    &-study {
      button {
        width: 1.5rem;
        height: 0.5rem;
        background: linear-gradient(
          -70deg,
          rgba(249, 185, 77, 1) 0%,
          rgba(253, 203, 118, 1) 99%
        );
        border-radius: 0.08rem;
        color: #fff;
        border: none;
      }
      position: absolute;
      right: 0.5rem;
      bottom: 0.3rem;
    }
    &-progress {
      width: 60%;
      color: #999999;
    }
    &-time {
      line-height: 3;
      font-size: 0.26rem;
      color: #999999;
    }
    &-exam {
      span {
        background: #fad9d9;
        padding: 0.05rem 0.1rem;
        color: #fc372d;
        margin-right: 0.2rem;
      }
      margin-top: 0.2rem;
    }
    &-branch {
      img {
        width: 0.21rem !important;
        height: 0.23rem;
        margin-right: 0.1rem;
      }
      display: flex;
      align-items: center;
      color: #999999;
      font-size: 0.26rem;
    }
    img {
      width: 100%;
    }
    width: 96%;
    margin: 0 auto;
    background: #fff;
    // margin-top: 0.4rem;
    position: relative;
    padding-bottom: 0.4rem;
  }
  font-size: 0.3rem;
}
</style>